import { render, staticRenderFns } from "./OpenRequestNotice.vue?vue&type=template&id=616eff6b&scoped=true"
import script from "./OpenRequestNotice.vue?vue&type=script&lang=js"
export * from "./OpenRequestNotice.vue?vue&type=script&lang=js"
import style0 from "./OpenRequestNotice.vue?vue&type=style&index=0&id=616eff6b&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616eff6b",
  null
  
)

export default component.exports